<template>
  <section>
    <wrapper-preview-category style="width: 48%">
      <template v-slot:header>Подписание заявки по аккредитациям</template>
      <v-divider class="my-3"/>
      <v-row>
        <v-col class="d-flex justify-start">
          <v-btn
              class="blue__v-btn mr-5"
              :loading="loadingFile"
              :disabled="isBlocked"
              @click="getReport"
          >
            Формы для самопроверки
          </v-btn>
        </v-col>
      </v-row>
      <v-divider class="my-3"/>
      <file-container :cols="9" :currentStage="currentStage" :files-config="filesConfig" :disabled="true"
                      ref="fileContainer"/>
      <div v-if="isValidSystemSetup && !hasConfirmFile">
        <v-row class="mt-2">
          <v-col class="d-flex justify-start">
            <div v-if="isValidSystemSetup">
              <v-autocomplete
                  v-model="chosenCertificate"
                  :items="certificatesList"
                  label="Выберите сертификат, которым будет произведена подпись данных"
                  no-data-text="Нет доступных сертификатов"
                  dense
                  class="mt-2"
                  clearable
                  outlined
              ></v-autocomplete>
              <v-btn class="blue__v-btn" :disabled="isBlocked" :loading="signingFile"
                     @click="signFile('Form4-2Foiv', 'downloadingPrint', 'FOUNDER_FORM42', null, `?founderId=${userId}`)">
                Подписать
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-if="!this.isBlocked && !isValidSystemSetup">
            <span class="red--text">Не установлен CryptoPro CAdES или плагин работает не правильно.
              Проверить проблемы можно на странице <a
                  href="https://cryptopro.ru/sites/default/files/products/cades/demopage/cades_bes_sample.html">Проверка создания электронной подписи CAdES-BES</a></span>
      </div>
    </wrapper-preview-category>
  </section>
</template>

<script>
import accreditationApprovedSign from "@/pages/Founders/configs/accreditationApprovedSign";
import {headerTooltipFunctions} from "@/mixins/forms5/headerTooltip";
import {tablePagination} from "@/mixins/tablePagination";
import {mapActions, mapGetters} from "vuex";
import {setCryptoProFunctions} from "@/mixins/cryptoProFunctions";
import {setFileFunctions} from "@/mixins/fileFucntions";
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory.vue";
import FileContainer from "@/containers/FileContainer.vue";

export default {
  name: "AccreditationAgreed",
  components: {FileContainer, WrapperPreviewCategory},
  mixins: [headerTooltipFunctions, tablePagination, setCryptoProFunctions, setFileFunctions],
  data() {
    return {
      serverDataBeforeFilter: [],
      loadingData: false,
      changingHeaders: false,
      loadingFile: false,
      searchOrg: '',
      search: '',
      searchFields: [
        {text: 'ID', value: 'sprOrgId'},
        {text: 'Наименование', value: 'orgName'},
      ],
      selectedSearchField: 'orgName',
      headers: accreditationApprovedSign,
      loadingMenu: {value: false, id: ''},
      full: false,
      rwrw: false,
      filesConfig: [
        {
          name: 'Подписанная форма 4.2',
          types: ['application/pdf'],
          typesForChose: ['application/pdf'],
          id: null,
          fileType: 'FOUNDER_FORM42',
          canUpload: false
        }
      ]
    }
  },
  computed: {
    ...mapGetters('checkFilled', {currentStage: 'currentStage', getFilesList: 'getFilesList'}),
    ...mapGetters('keycloak', {getKeycloakData: 'getKeycloakData'}),
    isBlocked() {
      return this.currentStage !== 4 || this.hasConfirmFile;
    },
    hasConfirmFile() {
      const cffile = this.getFilesList.filter(item => item.fileType === 'FOUNDER_FORM42')[0];
      return cffile !== undefined && cffile !== null && !!cffile.id;
    },
  },
  mounted() {
    if (!this.isBlocked)
      this.checkSystem()
  },
  created() {
    if (!this.isBlocked)
      this.checkSystem()
  },
  methods: {
    ...mapActions('notifications', {addNotification: 'addNotification'}),
    initFiles() {
      this.$refs.fileContainer.initFiles()
    },
    // updateFiles() {
    //
    // },
    async getReport() {
      this.loadingFile = true;
      await this.downloadPrint('Form4-2FoivTemp', 'downloadingPrint', 'Файл подтверждения введенных данных (для проверки).pdf', 'application/pdf', `?founderId=${this.userId}`)
      this.loadingFile = false;
    },
  },
}
</script>

<style scoped>

</style>